import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import ControlPanelButton from 'components/atoms/controlPanelButton';
import ExclamationIcon from 'components/atoms/icons/exclamation';
import { getPatientStatus, showResult } from 'utils';
import { API_PATIENT_STATUS } from 'services/dataService/resources';
import dataService from 'services/dataService';
import { useDispatch } from 'react-redux';
import UpdatePatientStatusModal from './modal';

const PatientStatusButton = ({ profile, afterChangeStatus }) => {
  const [popup, showPopup] = useState(false);
  const [loading, setLoading] = useState(false);
  const buttonRef = useRef();

  const {
    adminPanelPatients: { setPatientStatus },
  } = useDispatch();

  const status = getPatientStatus(profile.status);

  const getReloadInternalAdmissionForm = (newStatus) =>
    newStatus.toLowerCase().startsWith('inactive') ||
    newStatus.toLowerCase() === 'active';

  const handleSubmit = async (value) => {
    const postData = {
      patientGuid: profile.guid,
      status: value,
    };
    setLoading(true);

    const { error, data } = await dataService.updateOnly(
      API_PATIENT_STATUS,
      postData,
    );

    if (error) showResult(error);
    if (data) setPatientStatus(value);

    setLoading(false);

    const reloadInternalAdmissionForm = getReloadInternalAdmissionForm(value);
    afterChangeStatus({ reloadInternalAdmissionForm });
  };

  return (
    <div
      className="admin-patient-header-actions-call patient-status"
      ref={buttonRef}
    >
      <ControlPanelButton
        label="RPM Status"
        icon={ExclamationIcon}
        fillColor={!loading && status.color}
        disabled={loading}
        handleClick={() => showPopup(!popup)}
      />
      {popup && (
        <UpdatePatientStatusModal
          togglePopup={showPopup}
          handleClick={handleSubmit}
        />
      )}
    </div>
  );
};

PatientStatusButton.propTypes = {
  profile: PropTypes.shape({
    guid: PropTypes.string,
    title: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    covidStatus: PropTypes.string,
    status: PropTypes.string,
    birthDate: PropTypes.string,
  }),
  afterChangeStatus: PropTypes.func,
};

export default PatientStatusButton;
